module.exports = __webpack_public_path__ + "static/media/16UNODC17.55e4f674.jpg";